<template>
  <!--媒体资源-->
    <div class="event_managing">
      <div class="search">
        <div class="search_box">
          <div v-for="item in search" :class='["search_options_box"]'>
            <span style="width: 100px;">{{item.title}}</span>
            <el-select class="select" v-model="selectValue" placeholder="请选择项目" @change="getSelectProject(selectValue )">
              <el-option v-for="item2 in item.options" :label="item2.label" :value="item2.value" :key="item2.value"></el-option>
            </el-select>
          </div>
          <div class="search_btn_box">
            <button :class='["search_btn","green","icon_btn","clearborder"]' @click="getResourceList()"><span class="el-icon-search"></span>查找</button>
          </div>
          <div class="add_btn_box">
            <button :class='["add_btn","delete","icon_btn","clearborder"]'><span class="el-icon-delete"></span>批量删除</button>
            <button :class='["add_btn","delete","icon_btn","clearborder"]'><span class="el-icon-close"></span>取消</button>
            <button :class='["add_btn","add","icon_btn","clearborder"]' @click="uploading_show=!uploading_show"><span class="el-icon-upload2"></span>上传</button>
<!--            <button :class='["add_btn","add","icon_btn","clearborder"]'><span class="el-icon-upload"></span>同步到云端</button>-->
          </div>
        </div>
      </div>
      <!--table-->
      <div class="table_content">
        <table>
          <thead>
          <tr>
            <th style="width: 50px !important;">
              <input type="checkbox" name="issue_all">
            </th>
            <th style="width: 100px !important;">序号</th>
            <th>文件名称</th>
            <th>文件大小</th>
            <th>文件时长</th>
            <th>文件类型</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in resourcePageData">
            <td style="width: 50px !important;">
              <input type="checkbox" name="issue">
            </td>
            <td>{{index+1}}</td>
            <td>{{item.name}}</td>
            <td>{{item.time}}</td>
            <td>{{item.durations}}</td>
            <td>{{item.type}}</td>
            <td class="table_btn">
              <button class="paly" style="margin-right: 20px">删除</button>
              <button class="remove">下载</button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="table_paging">
        <p>当前记录<span>1</span>到<span>5</span>条，共<span>5</span>条记录
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>
          第<span>1</span>/<span>1</span>页
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>
        </p>
      </div>
      <!--查看上传记录-->
      <transition name="fade">
        <div class="mark" v-if="fix_show">
          <div class="mark_close" @click="fix_show=!fix_show"></div>
          <div :class='["information_box","light_border","weather_box"]'
               :style="[{width:'800px'},{'margin-top':'0px'}]">
            <div class="border_top_left"></div>
            <div class="border_top_right"></div>
            <div class="border_bottom_left"></div>
            <div class="border_bottom_right"></div>
            <div class="h_light_right" :style="{top:'95px'}"></div>
            <div class="information_content issue_search_box model">
              <h1>查看上传记录</h1>
              <div class="search_win">
                <div class="search_options_box" style="width: 250px;">
                  <span>音乐名称</span>
                  <input type="text" placeholder="请输入名称" style="width: 130px;">
                </div>
                <div v-for="item in search_win" class="search_options_box" style="width: 250px;">
                  <span>{{item.title}}</span>
                  <img src="/static/img/select.png" alt="" style="top: 28px;">
                  <select class="select">
                    <option v-for="item2 in item.select" v-bind:value='item2.option'>{{item2.option}}</option>
                  </select>
                </div>
                <div class="search_btn_box">
                  <button :class='["search_btn","green","icon_btn","clearborder"]'><span class="el-icon-search"></span>查找</button>
                </div>
              </div>
              <div class="table_content">
                <table>
                  <thead>
                  <tr>
                    <th>音乐名称</th>
                    <th>上传人</th>
                    <th>上传时间</th>
                    <th>审核状态</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item,index) in table_win">
                    <td>{{item.name}}</td>
                    <td>{{item.person}}</td>
                    <td>{{item.time}}</td>
                    <td>{{item.state}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="sbt_box">
                <button :class='["add_btn","delete","icon_btn","clearborder"]'>取消</button>
                <button :class='["add_btn","add","icon_btn","clearborder"]'>确定</button>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <!--上传音乐文件-->
      <transition name="fade">
        <div class="mark" v-if="uploading_show">
          <div class="mark_close" @click="uploading_show=!uploading_show"></div>
          <div :class='["information_box","light_border","weather_box"]'
               :style="[{width:'800px'},{'margin-top':'0px'}]">
            <div class="border_top_left"></div>
            <div class="border_top_right"></div>
            <div class="border_bottom_left"></div>
            <div class="border_bottom_right"></div>
            <div class="h_light_right" :style="{top:'95px'}"></div>
            <div class="information_content issue_search_box model">
              <h1>素材上传</h1>
              <div class="table_content">
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  :action="params.action"
                  :data="params.data"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-success="handleSuccess"
                  :on-error="handleError"
                  :file-list="fileList"
                  :auto-upload="false">
                  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>ew
                  <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload()">上传到服务器</el-button>
<!--                  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
                </el-upload>
              </div>
              <div class="sbt_box">
                <button :class='["add_btn","delete","icon_btn","clearborder"]' @click="uploading_show=!uploading_show">取消</button>
                <button :class='["add_btn","add","icon_btn","clearborder"]' @click="uploading_show=!uploading_show">确定</button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
</template>

<script>
    export default {
        name: "event_managing",
      data() {
        return {
          fileList: [],
          fix_show: false,
          uploading_show: false,
          projectId: "",
          search: [
            {
              title: '选择项目',
              options: [],
            },
          ],
          selectValue:'17e3b71e-b460-498e-b0ef-657d20bd6549',
          projectList:[],
          search_win: [
             {
              title: '上传人',
              select: [
                {option: "请选择"},
                {option: "张三"},
              ]
            }, {
              title: '审核状态',
              select: [
                {option: "请选择"},
                {option: "审核通过"},
              ]
            },
          ],
          issue_search: [
            {
              title: '选择群组',
              select: [
                {option: "全部群组"},
                {option: "项目1"},
              ]
            }, {
              title: '选择小组',
              select: [
                {option: "全部小组"},
                {option: "项目1"},
              ]
            },
          ],
          params:{
            action:"/api/v1/sounder/material/add",
            data: {"project":"17e3b71e-b460-498e-b0ef-657d20bd6549"},
          },
          resourcePageData: [],
          table_win: [
            {
              name:"野百合也有春天.mp3",
              person:"张三",
              time:"2019-08-28 14:06:25",
              state:"审核通过"
            },{
              name:"野百合也有春天.mp3",
              person:"张三",
              time:"2019-08-28 14:06:25",
              state:"审核通过"
            },{
              name:"野百合也有春天.mp3",
              person:"张三",
              time:"2019-08-28 14:06:25",
              state:"审核通过"
            },{
              name:"野百合也有春天.mp3",
              person:"张三",
              time:"2019-08-28 14:06:25",
              state:"审核通过"
            },{
              name:"野百合也有春天.mp3",
              person:"张三",
              time:"2019-08-28 14:06:25",
              state:"审核通过"
            },{
              name:"野百合也有春天.mp3",
              person:"张三",
              time:"2019-08-28 14:06:25",
              state:"审核通过"
            }
          ],
          uploading: [
            {
              name:"野百合也有春天.mp3",
              person:"张三",
            },{
              name:"野百合也有春天.mp3",
              person:"张三",
            },{
              name:"野百合也有春天.mp3",
              person:"张三",
            },{
              name:"野百合也有春天.mp3",
              person:"张三",
            },{
              name:"野百合也有春天.mp3",
              person:"张三",
            },{
              name:"野百合也有春天.mp3",
              person:"张三",
            },
          ],
          headers:{"Content-Type":"multipart/form-data"}
        }
      },
      methods:{
        InitLeftMenu: function () {
          this.$emit('getMessage', '5', '1');
        },


        //获取项目列表
        getProjectList:function(){
          fetch("/api/v1/project/list", {
            method: 'post',
            body: JSON.stringify({

            })
          })
            .then(result => {
              return result.json();//解析流
            })
            //.then(data => console.log(data))
            .then(data => {
              if (data.code == "200") {
                this.message = "项目数据获取成功";
                this.projectList = data.data;
                let options = this.search[0].options;
                for (let i=0;i<this.projectList.length;i++){
                  let projectObj = {};
                  projectObj.label = this.projectList[i].name;
                  projectObj.value = this.projectList[i].id;
                  options.push(projectObj);
                };
              } else {
                this.message = "数据更新异常，请重试";
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
            });
        },


        getResourceList: function () {
          fetch("/api/v1/sounder/material/list", {
            method: 'post',
            body: JSON.stringify({
              "page_start": 0,
              "page_size": 10,
              "project": this.selectValue
            })
          }).then(result => {
            return result.json();//解析流
          }).then(data => {
            if (data.code == "200") {
              this.resourcePageData = data.data;
            }
          }).catch((error) => {
            console.log(error);
          });
        },


        //文件上传
        submitUpload() {
          this.$refs.upload.submit();
        },
        handleRemove(file, fileList) {
          console.log(file, fileList);
        },
        handlePreview(file) {
          console.log(file);
        },
        handleSuccess(response, file, fileList){
          this.getResourceList();
        },
        handleError(err, file, fileList){
        },
        //获取列表
        // GetDataList:function(){
        //   fetch("/api/v1/material/list/", {
        //     method: 'post',
        //     body: JSON.stringify({
        //       "pageindex": 0,
        //       "pagecount": 5,
        //       "project": "f899dfb4a9094ac48fbb27b64021d5e1",
        //     })
        //   })
        //     .then(result => {
        //       return result.json();//解析流
        //     })
        //     .then(data => {
        //       this.data = data.data;
        //     })
        //     .catch((error) => {
        //       console.log(error);
        //     });
        // },
      },
      created() {
        this.getResourceList();
          this.InitLeftMenu();
          this.getProjectList();
          //this.GetDataList();

      },

    }
</script>

<style scoped>
  .event_managing{
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }
  .search {
    width: 100%;
    height: 100px;
    padding: 20px 0px 0px;
  }

  .search_box {
    width: 100%;
    height: 100%;
    margin-right: 10px;
    background: #16518d;
    border-radius: 6px;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    position: relative;
  }

  .search_options_box {
    width: 16%;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #ffffff;
    color: #ffffff;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 48px;
    right: 20px;
    cursor: pointer;
  }

  .search_btn_box {
    width: 80px;
    padding: 10px;
  }

  .clearborder {
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search_btn {
    width: 100%;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
  }

  .add_btn {
    width: 110px;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
    float: right;
    margin-right: 20px;
  }

  .icon_btn span {
    margin-right: 8px;
  }

  .green {
    background: #21b868;
    color: #FFFFFF;
  }

  .green:active {
    background: #15a95a;
  }

  .blue {
    background: #7aafeb;
    color: #FFFFFF;
  }

  .blue:active {
    background: #4699f7;
  }

  .yellow {
    background: #f2ae4d;
    color: #FFFFFF;
  }

  .yellow:active {
    background: #fa9b15;
  }


  .add_btn_box {
    /*width: 370px;*/
    padding: 10px;
    position: absolute;
    right: 0px;
  }

  .add {
    background: #7aafeb;
    color: #FFFFFF;
    box-shadow: 0 3px 0 #3574ba;
  }

  .add:active {
    background: #6ca3e2;
  }

  .publish {
    background: #21b868;
    color: #FFFFFF;
    box-shadow: 0 3px 0 #188d4f;
  }

  .publish:active {
    background: #188d4f;
  }

  .delete {
    background: #f2ae4d;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #dc8509;
  }

  .delete:active {
    background: #e7a342;
  }

  .table_content {
    width: 100%;
   /* height: calc(100% - 100px);*/
    padding: 20px 0px;
  }

  .table_content > table {
    width: 100%;
    height: 100%;
    border: 1px solid #094b8e;
    background-color: #16518d;
  }

  .table_content > table tr th {
    background-color: #0e345b;
  }

  .table_content > table tr td {
    /*background-color: #16518d;*/
  }

  .table_content > table input {
    width: 16px;
    height: 16px;
  }

  .table_content > table tr:nth-child(2n) {
    background-color: #11406f;
  }

  .table_content > table tr {
    /*border-bottom: 1px solid #225892;*/
    height: 62px
  }

  .table_content > table tr td, .table_content > table tr th {
    text-align: center;
    color: #FFFFFF;
  }

  .table_content > table tr th select {
    background: transparent;
    color: #FFFFFF;
    border: none;
    outline: none;

  }

  .table_content > table tr th select option {
    color: #333333;

  }

  .table_paging {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid #105ba8;
    border-radius: 6px;
  }

  .table_paging > p {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: right;
    margin-bottom: 0;
    color: #c1c2c6;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .table_paging > p > button {
    margin: 0 8px;
    width: 10px;
    height: 16px;
    border: none;
    outline: none;
  }

  .table_btn>button {
    color: #95bee5;
    background: transparent;
    border: 1px solid #95bee5;
    outline: transparent;
    padding: 5px 20px;
    border-radius: 6px;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
  .mark {
    position: absolute;
    width: calc(100% - 6px);
    height: calc(100% - 6px);
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    z-index: 99999;
    left: 0;
    top: 0;
  }

  .mark_close {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    left: 0;
    top: 0;
  }

  .model {
    padding: 20px;
    box-sizing: border-box;
  }

  .model > h1 {
    font-size: 20px;
    color: #00f0ff;
    height: 40px;
    line-height: 40px;
    padding-bottom: 10px;
    border-bottom: 1px dashed #264a7c;
    margin-bottom: 10px;
  }

  .model > h1 > div {
    float: right;
    width: auto;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .model > h1 > div > label {
    font-size: 16px;
    line-height: 40px;
    color: #FFFFFF;
    margin-bottom: 0;
  }

  .model > h1 > div > label > select, .model > h1 > div > label > input {
    border: 1px solid #FFFFFF;
    border-radius: 4px;
    background: transparent;
    height: 32px;
    line-height: 32px;
    margin: 0 5px;
    width: 120px;
    color: #FFFFFF;
    outline: none;
  }

  .model > h1 > div > label > select > option {
    color: #000000;
  }


  .sbt_box {
    width: 100%;
    height: 80px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search_win{
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
  }
  .state_btn>button{
    background: transparent;
    border: transparent;
    outline: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/6_loudspeaker/event_managing.vue